import { SessionExpiredDialog as Dialog } from '@ionq/legacy-ui';
import { useLocation } from 'react-router';
import { signOut } from '../lib/session';
import { useSession } from './SessionProvider';

// Enterprise parity: sign out (a dead cookie must not shadow the next
// sign-in), then land on the sign-in with the page as the return target.
export function SessionExpiredDialog() {
    const { isExpired, user } = useSession();
    const location = useLocation();

    const onLogIn = () =>
        void signOut({
            email: user.email,
            targetUri: `${location.pathname}${location.search}${location.hash}`,
        });

    return <Dialog open={isExpired} onLogIn={onLogIn} />;
}
